/** 消息
state: [{
    message_id: String,
    session_id: String,
    from: String,
    to: String,
    body: {
        message_id: String,
        session_id: String,
        user_jid: String,
        nick_name: String,
        type: String, //text、file、image、uploading(nosave)
        ---- type: text ----
        content: String
        ---- type: file, image, uploading ----
        file_id: 
        file_ext: String //"pdf", "word", "excel", "ppt"
        file_name: String
        file_size: String
        file_src: String
        ---- type: uploading ----
        percentage: Number  //uploading百分比，值范围：0～100
    },
    avatar: String,
    nick_name: String,
    created_at: Date,
    updated_at: Date,
    ---- ext ----
    status: String
    status_msg: String
    is_received: Boolean
}]
*/
import { createAction, createReducer } from 'redux-act';
import _ from 'underscore';
import { guid } from '../../utils';

const initialState = [];

function _mapItem(obj) {
    return _.extend({
        message_id: obj.message_id || guid(),
        created_at: new Date(),
        updated_at: new Date()
    }, obj);
}

function _addOrEdit(state, obj, method = 'push') {
    let item = _.find(state, { message_id: obj.message_id });
    if (item) {
        _.extend(item, _mapItem(_.extend({}, item, obj)));
    } else {
        state[method](_mapItem(obj));
    }
}

export const add = createAction('add');
export const edit = createAction('edit');
export const addOrEdit = createAction('addOrEdit');
export const insertOrEdit = createAction('insertOrEdit');
export const remove = createAction('remove');
export const removeBySessionId = createAction('removeBySessionId');
export const clear = createAction('clear');

export default createReducer({
    [add]: (state, obj) => {
        let arr;
        if (_.isArray(obj)) {
            arr = _.map(obj, (item) => {
                return _mapItem(item);
            });
        } else {
            arr = [_mapItem(obj)];
        }

        return [
            ...state,
            ...arr
        ];
    },

    [edit]: (state, obj) => state.map(item => {
        return item.message_id === obj.message_id ? _.extend(item, _mapItem(obj)) : item;
    }),

    [addOrEdit]: (state, obj) => {
        if (_.isArray(obj)) {
            _.each(obj, (item) => {
                _addOrEdit(state, item);
            });
        } else {
            obj && _addOrEdit(state, obj);
        }
        return [...state];
    },

    [insertOrEdit]: (state, obj) => {
        if (_.isArray(obj)) {
            _.each(obj, (item) => {
                _addOrEdit(state, item, 'unshift');
            });
        } else {
            obj && _addOrEdit(state, obj, 'unshift');
        }
        return [...state];
    },

    [remove]: (state, message_id) => state.filter(item => item.message_id !== message_id),

    [removeBySessionId]: (state, session_id) => state.filter(item => item.session_id !== session_id),

    [clear]: (state) => {
        state.length = 0;
        return [...state];
    }
}, initialState);


// WEBPACK FOOTER //
// ./src/msg/redux/index.js